import { gql } from "apollo-angular";

export const CREATE_CONTACT_US = gql`
    mutation CreateContactUs($input: CreateContactUsInput!) {
        createContactUs(input: $input) {
            id
            email
            phone
            message
            createdAt
        }
    }
`;
